import './confidentiality.scss';

const Confidentiality = () => {
  return (
    <div className="confidentiality content__confidentiality">
      <div className="confidentiality__wrapper">
        Справжня політика конфіденційності сайту фастфуду Grilla Food (далі - Політика конфіденційності)
        діє відносно сайту в мережі Інтернет за адресою ... (далі - Сайт).<br />
        <br />

        Використання сервісів Сайту означає беззастережну згоду користувача Сайту
        (далі - Користувача) з цієї Політикою конфіденційності та зазначеними
        в ній умовами обробки його персональної інформації.<br />
        <br />

        У разі незгоди з цими умовами користувач повинен утриматися від використання Сайту.<br />
        <br />

        <strong>1. Загальні положення</strong><br />
        1.1. В рамках цієї Політики конфіденційності під персональною інформацією користувача розуміються:<br />
        1.1.1. Персональна інформація, яку Користувач надає про себе самостійно в процесі використання
        сервісу оформлення доставки Сайту, включаючи персональні дані Користувача. Обов&#39;язкова для надання
        сервісів Сайту персональна інформація означена спеціальним чином. Інша (необов&#39;язкова)
        персональна інформація надається користувачем на його розсуд.<br />
        1.1.2. Дані, які автоматично передаються сервісами Сайту в процесі їх використання
        за допомогою встановленого на пристрої Користувача програмного забезпечення, в тому числі IP-адреса,
        дані файлів cookie, інформація про браузер Користувача (або іншої програми, за допомогою якої
        здійснюється доступ до сервісів Сайту), технічні характеристики устаткування і програмного
        забезпечення, що використовуються Користувачем, дата і час доступу до сервісів, адреси запитуваних
        сторінок і інша подібна інформація.<br />
        <br />

        1.2. Адміністрація Сайту не контролює і не несе відповідальності за сайти третіх осіб,
        на які Користувач може перейти по посиланнях, доступним на Сайті.<br />
        <br />

        <strong>2. Цілі обробки персональних даних користувачів</strong><br />
        2.1. Сайт збирає тільки ту персональну інформацію Користувача, яка необхідна для надання
        сервісу доставки Користувачеві.<br />
        2.2. Персональну інформацію Користувача Сайт обробляє в наступних цілях:<br />
        - ідентифікації Користувача при використанні їм сервісу доставки;<br />
        - надання послуг, обробки запитів і заявок від Користувача;<br />
        - встановлення з Користувачем зворотного зв&#39;язку, включаючи напрямок повідомлень і запитів;<br />
        - підтвердження повноти персональних даних, наданих Користувачем.<br />
        <br />

        <strong>3. Умови обробки персональної інформації користувачів і її передачі третім особам</strong><br />
        3.1. Щодо персональної інформації Користувача зберігається її конфіденційність, крім випадків
        добровільного надання Користувачем інформації про себе для загального доступу
        необмеженому колу осіб.<br />
        3.2. При використанні окремих сервісів Користувач погоджується з тим, що певна частина його
        персональної інформації стає загальнодоступною.<br />
        3.3. Обробка персональних даних Користувача здійснюється будь-яким законним способом, в
        тому числі в інформаційних системах персональних даних з використанням засобів автоматизації
        або без використання таких засобів.<br />
        3.4. Обробка персональних даних користувачів здійснюється відповідно до Закону України &laquo;
        Про захист персональних даних&raquo; № 2297-VI (далі - Закон).<br />
        3.5. Адміністрація Сайту вживає необхідних організаційних і технічних заходів для захисту
        персональної інформації Користувача від неправомірного або випадкового доступу, знищення,
        перекручення, блокування, копіювання, поширення, а також від інших неправомірних
        дій третіх осіб.<br />
        3.6. Адміністрація Сайту зобов&#39;язується не розголошувати персональну інформацію
        Користувача без попередньої письмової згоди користувача, а також не здійснювати
        її продаж, обмін, опублікування або розголошення іншими можливими способами.<br />
        3.5. Адміністрація Сайту використовує отриману інформацію виключно для цілей,
        зазначених у розділі 2 Політики конфіденційності.<br />
        <br />

        <strong>4. Вирішення спорів</strong><br />
        4.1. До цієї Політиці конфіденційності та відносин між Користувачем і Адміністрацією
        Сайту застосовується чинне законодавство України.<br />
        4.2. Обов&#39;язковою при вирішенні спорів, що виникають з відносин між Користувачем
        і Адміністрацією Сайту, є етап досудового врегулювання шляхом пред&#39;явлення претензії
        (письмового пропозиції про добровільне врегулювання спору). Одержувач претензії письмово
        повідомляє заявника про результати розгляду претензії.<br />
        4.3. При не досягненні угоди суперечка вирішується відповідно до чинного
        законодавства України.<br />
        <br />
        <strong>5. Додаткові умови</strong><br />
        5.1. Адміністрація Сайту має право вносити зміни в справжню Політику конфіденційності
        без згоди Користувача.<br />
        5.2. Нова Політика конфіденційності вступає в силу з моменту її розміщення на Сайті,
        якщо інше не передбачено новою редакцією Політики конфіденційності.
      </div>
    </div>
  );
}

export default Confidentiality;